import type { DateRange } from '../../store';

export const ALL_TIME_LABEL = 'Todos';

export function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getLast30Days(): DateRange {
  const today = new Date();
  const start = new Date(today);
  start.setDate(today.getDate() - 29);
  return { start: formatDate(start), end: formatDate(today) };
}

export function getThisMonth(): DateRange {
  const today = new Date();
  const start = new Date(today.getFullYear(), today.getMonth(), 1);
  return { start: formatDate(start), end: formatDate(today) };
}

export function getYearToDate(): DateRange {
  const today = new Date();
  const start = new Date(today.getFullYear(), 0, 1);
  return { start: formatDate(start), end: formatDate(today) };
}

export function getLast3Months(): DateRange {
  const today = new Date();
  const start = new Date(today.getFullYear(), today.getMonth() - 2, 1);
  return { start: formatDate(start), end: formatDate(today) };
}

export interface DatePreset {
  label: string;
  getRange: () => DateRange;
}

export const datePresets: DatePreset[] = [
  { label: 'Este año', getRange: getYearToDate },
  { label: 'Últimos 3 meses', getRange: getLast3Months },
  { label: 'Últimos 30 días', getRange: getLast30Days },
  { label: 'Este mes', getRange: getThisMonth },
];
